import * as Yup from "yup";
import i18next from "i18next";

const phoneRegExp = /^[0-9]{10,15}$/;

export const AddServiceProviderSchema = () => Yup.object({
    premise_id: Yup.string().required(i18next.t('serviceProvider.error_premise')),
    name: Yup.string().required(i18next.t('serviceProvider.error_name')),
    mobile: Yup.string().matches(phoneRegExp, i18next.t('serviceProvider.error_invalid_mobile')).required(i18next.t('serviceProvider.error_mobile')),
    type: Yup.string().required(i18next.t('serviceProvider.error_type')),
    sub_type: Yup.string().required(i18next.t('serviceProvider.error_sub_type')),
    validity: Yup.string().required(i18next.t('serviceProvider.error_validity')),
    status: Yup.string().required(i18next.t('serviceProvider.error_status')),

    id_type: Yup.string().notRequired(i18next.t('serviceProvider.error_id_type')),
    id_number: Yup.string().notRequired(i18next.t('serviceProvider.error_id_number')),

    present_address: Yup.string().notRequired(i18next.t('serviceProvider.error_present_address')),
    permanent_address: Yup.string().notRequired(i18next.t('serviceProvider.error_permanent_address')),

    police_verification: Yup.string().required(i18next.t('serviceProvider.error_police_verification')),
    is_hireable: Yup.string().required(i18next.t('serviceProvider.error_is_hireable')),
    is_frequent_visitor: Yup.string().required(i18next.t('serviceProvider.error_is_frequent')),
});